export class Disclaimer {
  id?: number;
  label?: string;
  text?: string;
  level?: number;
  expanded?: boolean;
  dismissible?: boolean;
  priority?: number;

  constructor(obj?: Disclaimer) {
    obj = obj || ({} as Disclaimer);
    this.id = obj.id || null;
    this.label = obj.label || '';
    this.text = obj.text || '';
    this.level = obj.level || null;
    this.expanded = obj.expanded || false;
    this.dismissible = obj.dismissible || false;
    this.priority = obj.priority || 50; // default priority if not assigned is 50
  }
}
